import { render, staticRenderFns } from "./UnitsOfMeasure.vue?vue&type=template&id=5bd71ab0"
import script from "./UnitsOfMeasure.vue?vue&type=script&lang=js"
export * from "./UnitsOfMeasure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports